import { render } from "./PreDeliveryOrderCard.vue?vue&type=template&id=31736b2e"
import script from "./PreDeliveryOrderCard.vue?vue&type=script&lang=js"
export * from "./PreDeliveryOrderCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__